import axios from 'axios'

export default {
  async getPictureTypes() {
    return (await axios.get(`/v1/cal/addresses/pictures/pictypes`)).data
  }
}
